import { createReducer } from "./../../../redux/reducers/functions";
import {
  SET_TRANSFERS_BY_USERS_LIST,
  SET_TRANSFERS_IS_LOADING,
  SET_TRANSFERS,
  SET_TRANSFERS_DETAILS
} from "./../actions/transfers";

const initialState = {
  isLoading: false,
  listByUsers: null,
  transfersList: null,
  transfersDetailsList: null
};

const transfersByUsersList = {
  [SET_TRANSFERS_BY_USERS_LIST]: (state, action) => {
    const transfersByUsers = action.payload;

    return { ...state, listByUsers: [...transfersByUsers] };
  }
};

const isLoading = {
  [SET_TRANSFERS_IS_LOADING]: (state, action) => {
    return { ...state, isLoading: action.payload };
  }
};

const transfersList = {
  [SET_TRANSFERS]: (state, action) => {
    return {
      ...state,
      transfersList: {
        ...action.payload
      }
    };
  }
};

const transfersDetailsList = {
  [SET_TRANSFERS_DETAILS]: (state, action) => {
    return {
      ...state,
      transfersDetailsList: {
        ...action.payload
      }
    };
  }
};

const transfersReducer = createReducer(initialState, {
  ...transfersByUsersList,
  ...isLoading,
  ...transfersList,
  ...transfersDetailsList
});

export default transfersReducer;



// WEBPACK FOOTER //
// src/modules/presence/reducers/transfers.js